module.exports = __webpack_public_path__ + "img/Stage_9_Diff.1d17f502.jpg";